'use client';
export {
  FocusScope,
  //
  Root,
} from './FocusScope';
export type { FocusScopeProps } from './FocusScope';
